import { getComparableShopifyId } from "./shopifyIds";

export type PdpVariant = {
  variantId: string;
  priceCents: number;
  compareAtPriceCents?: number;
  lawnSize: number;
};

export type VariantProduct<TVariant extends PdpVariant = PdpVariant> = {
  preselectedVariantId: string;
  variants: TVariant[];
};

export const formatMoney = (cents: number) =>
  new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(cents / 100);

export const getInitialVariantId = <TVariant extends PdpVariant>(
  product: VariantProduct<TVariant>,
) => product.preselectedVariantId || product.variants[0]?.variantId || "";

export const getSelectedVariant = <TVariant extends PdpVariant>(
  product: VariantProduct<TVariant>,
  selectedVariantId: string,
): TVariant | null =>
  product.variants.find((variant) => variant.variantId === selectedVariantId) ??
  product.variants.find(
    (variant) =>
      getComparableShopifyId(variant.variantId) ===
      getComparableShopifyId(selectedVariantId),
  ) ??
  product.variants.find(
    (variant) =>
      getComparableShopifyId(variant.variantId) ===
      getComparableShopifyId(product.preselectedVariantId),
  ) ??
  product.variants[0] ??
  null;

export const getVariantPrice = (variant: PdpVariant) => {
  const compareAtPrice = variant.compareAtPriceCents ?? variant.priceCents;
  const discountPercentage =
    compareAtPrice > variant.priceCents && compareAtPrice > 0
      ? Math.round(
          ((compareAtPrice - variant.priceCents) / compareAtPrice) * 100,
        )
      : 0;

  return {
    price: variant.priceCents,
    compareAtPrice,
    discountPercentage,
  };
};
